export default {
    name : 'manpowerContact',
    _elems : null,
    _container: null,

    init()
    {
        this.run();
    },
    run ()
    {
        this._elems = document.querySelectorAll('[data-contact-link]');
        
        if(!(this._elems)){
            return;
        }
        for (const elm of this._elems) {
            elm.addEventListener('click',(e)=>{
                e.preventDefault();
                const entryId = elm.getAttribute('data-contact-link');
                const xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.responseText) {
                        const contactContainer = document.querySelector('[data-contact-content]');
                        const result = JSON.parse(xhr.responseText);
                        contactContainer.classList.add(contactContainer.classList[0]+'--active') ;

                        const contactHead = contactContainer.getElementsByClassName('contact-popup__cat')[0];
                        contactHead.innerHTML = result.cat;
                      
                     //   console.log(result.img)
                        let htmlsnippet = `
                        <div class="contact-persons__item">
                            <div class="contact-persons__asset">
                                <img src="${result.img}" alt="">    
                            </div>
                            <div class="contact-persons__content bg-color-secondary">
			                    <h2 class="contact-persons__name text-center mt-0 mb-1">
                                    ${result.title}
			                    </h2>
			                    <span class="contact-persons__position d-block text-center mb-5">${result.position}</span>
			                    <a class="link link--accent with-arrow-left semi-bold d-block text-left mb-2" href="tel:${result.phone}">${result.phone}</a>
			                    <a class="link link--accent with-arrow-left semi-bold d-block text-left" href="mailto:${result.email}">${result.email}</a>
			                </div>
                        </div>
                       ` ;
                        let containerInfo = contactContainer.getElementsByClassName('contact-popup__info')[0];
                     
                        containerInfo.innerHTML =  htmlsnippet;

                        const containerClose = document.querySelector('[data-contact-close]');
                        containerClose.addEventListener('click',()=>{
                            contactContainer.classList.remove(contactContainer.classList[0]+'--active') ;
                            containerInfo.innerHTML = "";
                        })
                    } else {
                        console.error('ERROR: Could not GET contact');
                    }
                }
                let params = JSON.stringify({ 'entryId': entryId });
                xhr.open('post', 'actions/tibe/contact/contact',true);
                xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
                xhr.send(params);
            })            
        }
    }
}